Object.defineProperty(exports, "__esModule", { value: true });
exports.useInitThemeSwitcher = void 0;
const react_1 = require("react");
const admin_core_1 = require("@wheelroom/admin-core");
const theme_switcher_register_1 = require("./theme-switcher-register");
const theme_switcher_reducer_1 = require("./theme-switcher-reducer");
const initial_state_1 = require("./initial-state");
const action_creator_1 = require("./action-creator");
exports.useInitThemeSwitcher = (themeInfo) => {
    const { adminCoreDispatch } = react_1.useContext(admin_core_1.AdminCoreContext);
    initial_state_1.initialState.themes = themeInfo.themes;
    initial_state_1.initialState.activeThemeId = themeInfo.defaultThemeId;
    initial_state_1.initialState.lastThemeId = initial_state_1.initialState.activeThemeId;
    const [themeSwitcherState, themeSwitcherDispatch] = react_1.useReducer(theme_switcher_reducer_1.themeSwitcherReducer, initial_state_1.initialState);
    const actions = action_creator_1.actionCreator(themeSwitcherState, themeSwitcherDispatch);
    react_1.useLayoutEffect(() => {
        if (themeInfo.pageThemeId) {
            actions.setTemporaryActiveTheme(themeInfo.pageThemeId);
        }
        else {
            actions.setLastTheme();
        }
    }, [themeInfo.pageThemeId]);
    react_1.useEffect(() => {
        adminCoreDispatch(theme_switcher_register_1.themeSwitcherRegister);
    }, []);
    react_1.useLayoutEffect(() => {
        adminCoreDispatch({
            type: 'SET_ADMIN_MODULE_STORE',
            moduleId: theme_switcher_register_1.themeSwitcherRegister.moduleId,
            store: {
                actions,
                state: themeSwitcherState,
                dispatch: themeSwitcherDispatch,
            },
        });
        adminCoreDispatch({
            type: 'SET_LAST_MODULE_ID',
            moduleId: theme_switcher_register_1.themeSwitcherRegister.moduleId,
        });
    }, [themeSwitcherState]);
};
//# sourceMappingURL=use-init-theme-switcher.js.map